const PORTFOLIO_ITEMS = [
  {
    img: "https://storage.readdy-site.link/project_files/f94c1989-fcbf-47d1-a7b5-4805e349c998/8cc74ac7-e043-45d2-af56-d89b826ada38_construlife-casa2-2.jpg?v=4018e51ed471f7caa6aebee2ec4ca701",
    title: "Residência Moderna Alto Padrão",
    category: "Design de Fachada",
  },
  {
    img: "https://storage.readdy-site.link/project_files/f94c1989-fcbf-47d1-a7b5-4805e349c998/7f3cb7d4-10d9-4200-8a27-3ff8b3e47426_construlife-casa3-2.jpg?v=2bab9ebcb30e3dc763208b0cd9ebfb3a",
    title: "Edifício Comercial Corporate",
    category: "Design de Fachada",
  },
  {
    img: "https://storage.readdy-site.link/project_files/f94c1989-fcbf-47d1-a7b5-4805e349c998/7c85b52e-f56a-44f9-a250-40e54f79e72f_construlife-casa5.png?v=3824f4a7f4f7bec7aecc7d4d9d2cdaf3",
    title: "Fachada Residencial Renovada",
    category: "Design de Fachada",
  },
  {
    img: "https://storage.readdy-site.link/project_files/f94c1989-fcbf-47d1-a7b5-4805e349c998/eb56e6f1-2137-4b30-bbdc-84cb1906cdd1_construlife-interior.png?v=081d2f202ec70d88209014352b5a28d4",
    title: "Design de Interiores Premium",
    category: "Design de Interiores",
  },
  {
    img: "https://storage.readdy-site.link/project_files/f94c1989-fcbf-47d1-a7b5-4805e349c998/292a6c3e-cfe9-4e17-bae0-57b6c6819307_construlife-projeto.jpg?v=18d2b10439975ab511a4c88d5bfaea30",
    title: "Projeto Técnico Completo",
    category: "Design de Fachada",
  },
  {
    img: "https://storage.readdy-site.link/project_files/f94c1989-fcbf-47d1-a7b5-4805e349c998/7c56f50d-2bbb-4b91-a738-c5ec19fffc54_construlife.png?v=d0a387447f3bd25f7a3d94c5f63d3c81",
    title: "Complexo Residencial Urbano",
    category: "Design de Interiores",
  },
];

export default function PortfolioSection() {
  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#2563EB] text-xs font-semibold tracking-widest uppercase mb-3 block">
            Nosso trabalho
          </span>
          <h2 className="text-[#1F1F1F] font-bold text-4xl md:text-5xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Projetos Realizados
          </h2>
          <div className="w-16 h-1 mx-auto bg-[#C9A24A]" />
          <p className="text-[#7A7A7A] text-lg mt-5 max-w-xl mx-auto">
            Conheça alguns dos projetos que desenvolvemos com dedicação e excelência técnica.
          </p>
        </div>

        {/* Grid / Carousel */}
        <div className="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-6 flex overflow-x-auto gap-4 snap-x snap-mandatory pb-4 md:pb-0 scrollbar-hide">
          {PORTFOLIO_ITEMS.map((item) => (
            <div
              key={item.title}
              className="relative rounded-xl overflow-hidden cursor-pointer flex-shrink-0 w-[80vw] sm:w-[70vw] md:w-auto snap-start"
              style={{ height: "260px" }}
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover object-bottom transition-transform duration-500"
              />
              {/* Category badge always visible */}
              <div className="absolute top-4 left-4">
                <span className="bg-[#2563EB] text-white text-xs font-medium px-3 py-1 rounded-full">
                  {item.category}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="inline-flex items-center gap-2 border-2 border-[#2563EB] text-[#2563EB] hover:bg-[#2563EB] hover:text-white font-semibold px-8 py-4 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer">
            Ver Todos os Projetos
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
